import * as yup from 'yup';
import { yupObjectCreditCardNotRequired, yupObjectCreditCardRequired } from './yupObjectCreditCard';
import { yupObjectPersonDetails } from './yupObjectPersonDetails';
import { yupObjectContactDetails } from './yupObjectContactDetails';
import { yupObjectFiles } from './yupObjectFiles';
import { yupObjectCar } from './yupObjectCar';
import { yupObjectAdditionalContactDetailsNotRequired, yupObjectAdditionalContactDetailsRequired } from './yupObjectAdditionalContactDetails';
import { REQUIRED_FIELD_PATH } from '../../errorMessages';


export const requestSchema = yup.object().shape({
    carDetails: yup
        .object()
        .shape(yupObjectCar),
    personDetails: yup
        .object()
        .shape(yupObjectPersonDetails),
    contactDetails: yup
        .object()
        .shape(yupObjectContactDetails),
    additionalContactDetails: yup
        .object()
        .shape(yupObjectAdditionalContactDetailsRequired)
        .when(["hasAdditionalAddress"], ([hasAdditionalAddress], schema) => {

            return (hasAdditionalAddress === 0) ? schema.shape(yupObjectAdditionalContactDetailsNotRequired) : schema
        }),
    extraFiles: yup
        .object()
        .shape(yupObjectFiles),
    agreeTakanon: yup.string()
        .test(
            "agreeTakanon_",
            REQUIRED_FIELD_PATH,
            (value) => value === String(1)
        ),
    craditCard: yup
        .object()
        .shape(yupObjectCreditCardNotRequired)
        .when(["paymentAmount"], ([paymentAmount], schema) => {
            return (paymentAmount === 0) ? schema : schema.shape(yupObjectCreditCardRequired)
        }),
});